<template>
  <span class="chip" :style="PERIOD_STATUS_STYLE[status]" :title="title">
    <CalendarIcon v-if="icon" class="w-3 h-3" />{{ text }}
  </span>
</template>

<script setup>
import { computed } from "vue";
import { periodLabel, periodStatus, PERIOD_STATUS_LABEL, PERIOD_STATUS_STYLE } from "../period";

/** "ปี 2569" / "ทุกปี" / "1 ต.ค. 2568 – 30 ก.ย. 2569", coloured by whether it can be applied for today */
const props = defineProps({
  period: { type: Object, default: null },
  icon: { type: Boolean, default: false },
  statusOnly: { type: Boolean, default: false },   // just "หมดอายุแล้ว" / "ยังไม่เริ่ม" (inside small welfare chips)
});
const status = computed(() => periodStatus(props.period));
const text = computed(() => {
  if (props.statusOnly) return PERIOD_STATUS_LABEL[status.value];
  const label = periodLabel(props.period);
  return status.value === "expired" ? `${label} · หมดอายุ` : status.value === "upcoming" ? `${label} · ยังไม่เริ่ม` : label;
});
const title = computed(() => `${periodLabel(props.period)} — ${PERIOD_STATUS_LABEL[status.value]}`);
</script>
